import React from 'react';

import { onSessionSyncListner } from '../firebase/api/auth';

const withStorageSync = Component => {
    class withStorageSync extends React.Component {
        componentWillUnmount() {
            onSessionSyncListner(authUser => {
                localStorage.setItem('authUser', JSON.stringify(authUser));
            });
        }

        render() {
            return (
                <withStorageSync>
                    <Component {...this.props} />
                </withStorageSync>
            );
        }
    }

    return withStorageSync;
};

export default withStorageSync;
